// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

import { ServiceConfig } from './service-config';

export class SigRConfig extends ServiceConfig {
}